<template>
  <v-row>
    <v-col>
      <reset-password-card />
    </v-col>
  </v-row>
</template>

<script>
import ResetPasswordCard from '@/components/unauth/ResetPasswordCard';

export default {
  name: 'LoginView',
  components: {
    ResetPasswordCard,
  },
};
</script>
